import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter } from '@angular/core';
import { BeyondEmergencyCreditModel } from '../../models/payg/beyond-emergency-credit.model';
import { IssueService } from '../../services/issue.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { DataService } from '../../services/data.service';


@Component({
    selector: 'beyond-emergency-credit-item',
    templateUrl: './beyond-emergency-credit-item.component.html'
})
export class BeyondEmergencyCreditItemComponent implements OnInit, OnDestroy {

    isExpanded: boolean;
    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    emergencyCreditDetail: BeyondEmergencyCreditModel[] = [];
    totalPages: number = 1;
    accountPage: number = 1;
    pageSize: number = 10;
    isSearching: boolean = false;


    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['accountPage']) {
                    this.accountPage = +queryParams['accountPage'];
                }
            }));


        this.issueService.issuePAYGEmergencyCreditDetail(this.clientId, this.accountPage, this.pageSize, this.timePeriod, this.siteId).then(
            (result: any) => {
                this.emergencyCreditDetail = result.items;
                this.pageSize = result.pageSize;
                this.totalPages = result.totalPages;
                this.accountPage = result.currentPage;
                if (this.accountPage > this.totalPages) {
                    this.accountPage = this.totalPages;
                }

                this.dataService.beyondEmergencyCreditItemComponentResolved.next(result.items.length > 0);
            },
            error => {
                this.dataService.beyondEmergencyCreditItemComponentResolved.next(false);
            }
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    toggleExpand() {
        this.isExpanded = !this.isExpanded;
    }

    pageSelected(page: number) {
        this.accountPage = page;
        this.getPage(page);
    }

    getPage(page: number) {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.accountPage = page;

        this.issueService.issuePAYGEmergencyCreditDetail(this.clientId, this.accountPage, this.pageSize, this.timePeriod, this.siteId).then((result) => {
            var result = (result as any);
            this.emergencyCreditDetail = result.items;
            this.pageSize = result.pageSize;
            this.totalPages = result.totalPages;
        });
    }

    onInfoClick() {
        swal({
            title: 'Beyond emergency credit',
            html: '<p style="text-align: left;">Emergency credit (E/C) acts as an overdraft for consumers who are no longer in credit.</p>\
            <p style="text-align: left;">This widget highlights consumers whose credit status is beyond their set E/C limit.</p>\
            <p style="text-align: left;">Consumers with meters that continue to register usage despite being beyond their E/C limit should be investigated as a priority. This may suggest a fault or tampering as well as carrying a risk of causing fuel poverty or increasing debt risk to you.</p>\
            <p style="text-align: left;">Where a consumer’s meter has stopped registering usage following exhaustion of their E/C they have no supply, you may wish to consider this is as a welfare issue as well an increased debt risk and fuel poverty. Please note, standing charges continue to accrue on PAYG.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
